export const productBelongsToCategory = (product, productCategoryNo) =>
  product?.productCategoryNo === productCategoryNo ||
  (product?.additionalProductCategoryNos ?? []).includes(productCategoryNo);
